import _RentalPropertyService from "../services/rental-property-service";
import { IRentalPropertyService } from "../types/services/rental-property-service";

const RentalPropertyService: IRentalPropertyService = new _RentalPropertyService();

export default RentalPropertyService;
